export default {
  path: '/selos-virtuais/:id',
  component: () => import('@/components/pages/VirtualSeals/VirtualSeal.vue')
}
